export function safeDecodeBase64Json<T = unknown>(
  base64String: string | null | undefined,
): T | null {
  if (!base64String) return null;
  try {
    // Handle standard and url-safe base64 characters
    let b64 = base64String.trim().replace(/-/g, "+").replace(/_/g, "/");
    // Pad to a multiple of 4 (required by atob / Buffer)
    const pad = b64.length % 4;
    if (pad) {
      b64 += "=".repeat(4 - pad);
    }

    const decodedStr = decodeBase64ToString(b64);
    return JSON.parse(decodedStr) as T;
  } catch {
    return null;
  }
}

function decodeBase64ToString(b64: string): string {
  // Prefer Buffer in Node (tests / SSR) — more reliable than atob for binary.
  if (typeof Buffer !== "undefined") {
    return Buffer.from(b64, "base64").toString("utf8");
  }

  // Browser fallback
  if (typeof atob === "function") {
    const binary = atob(b64);
    if (typeof TextDecoder !== "undefined") {
      const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
      return new TextDecoder().decode(bytes);
    }
    // Latin-1 / ASCII JSON payloads
    return binary;
  }

  throw new Error("No base64 decoder available");
}
